module.exports = __webpack_public_path__ + "img/sales.a8a92586.svg";